type PlaceholderType = {
  fill?: string
  width?: string
  height?: string
  title?: string
}

function Placeholder(props: PlaceholderType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1.8em'
  const height = props.height || '1.8em'
  const title = props.title || 'placeholder'

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 30 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <g>
        <path
          id='Vector'
          d='M1 27.9523C3.13642 22.136 8.59513 18 14.9913 18C21.405 18 26.876 22.1586 29 28'
          stroke={fill}
          strokeWidth='2'
          strokeMiterlimit='10'
        />
        <path
          id='Vector_2'
          d='M15 13C18.3137 13 21 10.3137 21 7C21 3.6863 18.3137 1 15 1C11.6863 1 9 3.6863 9 7C9 10.3137 11.6863 13 15 13Z'
          stroke={fill}
          strokeWidth='2'
          strokeMiterlimit='10'
        />
      </g>
    </svg>
  )
}

export default Placeholder
